import { API } from '../API/API';
import jwt_decode from "jwt-decode";

export const refreshToken = () => {
    if (localStorage.getItem('userInfo')) {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return API.post('/api/shared/user-management/auth/refresh-token', {
            refreshToken: userInfo.refreshtoken
        }).then(result => {
            
            userInfo = {
                ...userInfo,
                accesstoken: result.data.accesstoken,
                expiresat: result.data.expiresat,
                refreshtoken: result.data.refreshtoken,
                refreshtokenexpiresat: result.data.refreshtokenexpiresat,
                features: result?.data?.features?.length > 0 ? result.data.features : []
            };
            localStorage.setItem('userInfo', JSON.stringify(userInfo));

            return result;
        }, error => {
            localStorage.removeItem('userInfo');
            window.location.reload();
        });
    } else {
        localStorage.removeItem('userInfo');
        window.location.reload();
    }
}

export const isEdit = (accesstoken, roles) => {

    let tEdit = false;

    let tRoles = [];
    if (accesstoken) {
        let tDecodeJwt = jwt_decode(accesstoken);
        if (tDecodeJwt?.roles?.length > 0) {
            tRoles = tDecodeJwt?.roles;
        }
    }

    if (roles?.length > 0 && tRoles.some(r => roles?.includes(r))) {
        tEdit = true;
    }

    return tEdit;
}